import { Rule } from 'antd/es/form';

export enum INSURANCE_TYPE {
  DOM = 'DOM', // nội địa
  INT = 'INT', // quốc tế
  DEL = 'DEL', // trễ chuyến
  ALI = 'ALI', // BH TNDS cho xe ô tô
  INB = 'INB', // nhập cảnh
}

export enum ITINERARY_TYPE {
  ONE_WAY = 1,
  ROUND_TRIP = 2,
}

export const InsuranceTypeOptions = [
  {
    label: 'Nội địa',
    value: INSURANCE_TYPE.DOM,
  },
  {
    label: 'Quốc tế',
    value: INSURANCE_TYPE.INT,
  },
  // TODO: Tạm thời đóng do nhà cung cấp chưa mở dịch vụ
  // {
  //   label: 'Trễ chuyến',
  //   value: INSURANCE_TYPE.DEL,
  // },
  // {
  //   label: 'Ô tô',
  //   value: INSURANCE_TYPE.ALI,
  // },
];

export enum SORT_BY {
  PRICE,
  INSURANCE_PACKAGE_NAME,
}

export enum CONTRACT_TYPE {
  ALL = 'ALL',
  EACH = 'EACH',
}

export enum INVOICE_STATUS {
  CANCELED = 'CANCELED',
  ISSUED = 'ISSUED',
  ISSUE_REQUEST = 'ISSUE_REQUEST',
  ON_REQUEST = 'ON_REQUEST',
  REQUEST = 'REQUEST',
}

export enum SUBMIT_FLIGHT_STATUS {
  PAID = 'PAID',
  PAID_HOLD = 'PAID_HOLD',
  PAID_HOLD_FAILED = 'PAID_HOLD_FAILED',
  PAID_ISSUE_FAILED = 'PAID_ISSUE_FAILED',
  WAIT_PAYMENT = 'WAIT_PAYMENT',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_CANCELED = 'PAYMENT_CANCEL',
  BOOK_PENDING = 'BOOK_PENDING',
  BOOK_SUCCESS = 'BOOK_SUCCESS',
  BOOK_FAILED = 'BOOK_FAILED',
  ISSUE_WAITING = 'ISSUE_WAITING',
  ISSUE_GRANTED = 'ISSUE_GRANTED',
  ISSUE_REQUEST = 'ISSUE_REQUEST',
  ISSUE_SUCCESS = 'ISSUE_SUCCESS',
  ISSUE_FAILED = 'ISSUE_FAILED',
  CANCELED = 'CANCELED',
  CHECKIN = 'CHECKIN',
  REFUND_REQUEST = 'REFUND_REQUEST',
  REFUNDED = 'REFUNDED',
  DELETED = 'DELETED',
}

export enum PAYMENT_OPTIONS {
  DEPOSIT = 'DEPOSIT',
  VTELMON = 'VTELMON',
  VNPAYGW = 'VNPAYGW',
}

export enum TYPE_IMPORT {
  MANUAL,
  EXCEL,
}

export enum FORM_FIELD {
  VEHICLE_INFO = 'vehicleInfo',
  BRAND_CODE = 'brandCode',
  LINE_CODE = 'lineCode',
  LICENSE_PLATE = 'licensePlate',
  VIN_NUMBER = 'vinNumber',
  ENGINE_NUMBER = 'engineNumber',
  MANUFACTURE_DATE = 'manufactureDate',
  REGISTERED_DATE = 'registeredDate',
  REGISTERED_ADDRESS = 'registeredAddress',
  OWNER_FULL_NAME = 'ownerFullName',
  VEHICLE_COVERAGE = 'vehicleCoverage',
  START_DATE = 'startDate',
  INSURANCE_PERIOD = 'insurancePeriod',
  COVERAGE_OPTIONS = 'coverageOptions',
  COVERAGE_SESSION = 'coverageSession',
  OPTION_SESSION = 'optionSession',
  INSURED_UNITS = 'insuredUnits',
}

export const FormLabel: Record<FORM_FIELD, string> = {
  [FORM_FIELD.VEHICLE_INFO]: 'Thông tin phương tiện',
  [FORM_FIELD.BRAND_CODE]: 'Hãng phương tiện',
  [FORM_FIELD.LINE_CODE]: 'Dòng phương tiện',
  [FORM_FIELD.LICENSE_PLATE]: 'Biển số',
  [FORM_FIELD.VIN_NUMBER]: 'Số VIN',
  [FORM_FIELD.ENGINE_NUMBER]: 'Số máy',
  [FORM_FIELD.MANUFACTURE_DATE]: 'Thời gian sản xuất',
  [FORM_FIELD.REGISTERED_DATE]: 'Thời gian bắt đầu sử dụng',
  [FORM_FIELD.REGISTERED_ADDRESS]: 'Địa chỉ đăng ký',
  [FORM_FIELD.OWNER_FULL_NAME]: 'Họ tên chủ xe',
  [FORM_FIELD.VEHICLE_COVERAGE]: 'Thông tin bảo hiểm phương tiện',
  [FORM_FIELD.START_DATE]: 'Thời gian bắt đầu',
  [FORM_FIELD.INSURANCE_PERIOD]: 'Thời hạn bảo hiểm',
  [FORM_FIELD.COVERAGE_OPTIONS]: 'Danh sách tuỳ chọn bảo hiểm',
  [FORM_FIELD.COVERAGE_SESSION]: 'Session tuỳ chọn',
  [FORM_FIELD.OPTION_SESSION]: 'Số tiền bảo hiểm',
  [FORM_FIELD.INSURED_UNITS]: 'Số người tham gia',
};

export const FormValidation: Record<FORM_FIELD, Rule[]> = {
  [FORM_FIELD.VEHICLE_INFO]: [],
  [FORM_FIELD.BRAND_CODE]: [{ required: true }],
  [FORM_FIELD.LINE_CODE]: [{ required: true }],
  [FORM_FIELD.LICENSE_PLATE]: [{ required: true }],
  [FORM_FIELD.VIN_NUMBER]: [{ required: true }],
  [FORM_FIELD.ENGINE_NUMBER]: [{ required: true }],
  [FORM_FIELD.MANUFACTURE_DATE]: [{ required: true }],
  [FORM_FIELD.REGISTERED_DATE]: [{ required: true }],
  [FORM_FIELD.REGISTERED_ADDRESS]: [{ required: true }],
  [FORM_FIELD.OWNER_FULL_NAME]: [{ required: true }],
  [FORM_FIELD.VEHICLE_COVERAGE]: [],
  [FORM_FIELD.START_DATE]: [{ required: true }],
  [FORM_FIELD.INSURANCE_PERIOD]: [{ required: true }],
  [FORM_FIELD.COVERAGE_OPTIONS]: [{ required: true }],
  [FORM_FIELD.COVERAGE_SESSION]: [{ required: true }],
  [FORM_FIELD.OPTION_SESSION]: [{ required: true }],
  [FORM_FIELD.INSURED_UNITS]: [{ required: true, message: 'Nhập thông tin số người tham gia' }],
};
